const baseUrl = {
  // development: 'http://192.168.40.117:5000/',
  development: process.env.REACT_APP_BASE_URL,
  production: process.env.REACT_APP_BASE_URL,
}
const Config =  {
  "serverUrl" : baseUrl[process.env.NODE_ENV]
}

export default Config